
//  const MultiSelect = forwardRef(({
    //     availText, 
//     SelectedText, 
//     lsElements,
//     selectedElts,
//     addElement
//  }, ref) => {

    
import {  useRef, useState } from 'react';
import './MultiSelect.css';
import { useToast } from '../../CustomeHooks/useToast';

const MultiSelect = ({
        availText,
        // SelectedText,
        lsElements,
        onChangeSelection,
        _selectedCategories,
        maxCategories
    }) => {

    //const [remainingNb, setRemainingNb] = useState(maxCategories - _selectedCategories.length);


    const getDiff = (arr1, arr2) => {
        const remaining = [...arr1];
        for (let i = 0; i < arr2.length; i++) {
            var sel = arr1.find(cat => cat.Id === arr2[i].Id);
            if(sel) {
                remaining.splice(remaining.indexOf(sel), 1);
            }
        }
        return remaining;
    }

    // Remaining Categories = lsElements(aka All) - _selectedCategories
    const [remainingCategories, setRemainingCategories] = useState(getDiff(lsElements, _selectedCategories));
    const [selectedCategories, setSelectedCategories] = useState([..._selectedCategories]);
    //console.log(selectedCategories);

    //const selectedCategoriesIDs = useRef("");

    const [searchText, setSearchText] = useState("");
    const toast = useToast();

    const onAddElt = (_el) => {
        if(selectedCategories && selectedCategories.length >= maxCategories) {
            toast('warning', "Cannot add more categories !");
            return;
        }
        
        // Push the "New Category" in the "Selected Categories" array.
        var tempSelected = [...selectedCategories, _el];
        // Sort categories
        tempSelected.sort((a, b) => {
            const nameA = a.Name.toUpperCase(); // ignore upper and lowercase
            const nameB = b.Name.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) { return -1;}
            if (nameA > nameB) { return 1; }
            return 0;
        });
        // Set the selected categories.
        setSelectedCategories(tempSelected);
        
        // Remove the "New Category" from the "Remaining array".
        var tempRem = remainingCategories.filter(skill => skill.Id !== _el.Id);
        setRemainingCategories(tempRem);

        //selectedCategoriesIDs.current += _el.Id + ",";
        
        onChangeSelection(tempSelected);
        //setRemainingNb(maxCategories - tempSelected.length);

        // old code
        //setSelectedCategories(el => [...el, _el]);
        //setRemainingCategories(lsElements => {
        //    return lsElements.filter(skill => skill.Id !== _el.Id)
        //});
    };

    const deleteElt = (_elt) => {

        setSelectedCategories(selectedCategories => {
            return selectedCategories.filter(skill => skill.Id !== _elt.Id);
        });
        //selectedCategoriesIDs.current = selectedCategoriesIDs.current.replaceAll(_elt.Id + ",", "");
        //console.log(selectedCategoriesIDs.current);
        setRemainingCategories(e => [...e, _elt]);
        onChangeSelection(selectedCategories.filter(skill => skill.Id !== _elt.Id));
        
        //setRemainingNb(maxCategories - selectedCategories.length + 1);
    }

    const onChangeText = (e) => {
        if(e && e.target && e.target) {
            setSearchText(e.target.value);
        }
    }


    return(
        <>
            <div className='mutliselect-component'>
                <div className='left-side'>
                    <div className='selected-text'>
                        { 
                            selectedCategories.length <= maxCategories ?
                            <>
                                Notify me for : <span className='remaining-text'>
                                    ({ selectedCategories.length } of { maxCategories } selected)
                                </span>
                            </>
                            :
                            <>
                                <span className='remaining-text-error'>
                                    You reached the max number of categories
                                </span>
                            </>
                        }
                    </div>
                    <div className='all-sel-cat'>
                    {
                            selectedCategories && 
                            Array.isArray(selectedCategories) && 
                            selectedCategories.length > 0 && 
                            selectedCategories.map((selElt, key) => {
                            return(
                                selElt &&
                            
                                    <div key={ key } className='selected-row'>
                                        <div className='cat-name'>
                                            { selElt && selElt.Name }
                                        </div>
                                        {/* <div className='x-icon-container'>
                                            <i className="x-icon" onClick={() => deleteElt(selElt)}>x</i>
                                        </div> */}
                                        <div style={{ opacity: "0.7", 
                                                        color: "red",
                                                        // width: "20px", 
                                                        cursor: "pointer",
                                                        border: "solid 1px rgba(255, 0, 0, 0.26)",
                                                        borderRadius: "2px",
                                                        padding: "1px 5px"
                                                    }}
                                             onClick={() => deleteElt(selElt)}>
                                            <i className="fa fa-trash-o x-icon"
                                               aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    
                                
                            )
                        })
                    }
                    </div>
                </div>
                <div className='right-side'>
                    {/* <div>
                        { availText }
                    </div> */}
                    <div className='search-cat-div'>
                        {/* <form> */}
                            <input type="text" 
                                   className='search-category'
                                   name="search"
                                   style={{ padding: "5px 10px", }}
                                   autoComplete='off'
                                   value={ searchText }
                                   onChange={ onChangeText }
                                   placeholder='Type to search ...' />
                        {/* </form> */}
                    </div>
                    <div multiple className="available-elts">
                        {
                            remainingCategories.filter(cat => cat.Name
                                                                 .toLowerCase()
                                                                 .includes(searchText.toLowerCase()))
                                                                 .sort((a, b) => {
                                                                    const nameA = a.Name.toUpperCase(); // ignore upper and lowercase
                                                                    const nameB = b.Name.toUpperCase(); // ignore upper and lowercase
                                                                    if (nameA < nameB) { return -1;}
                                                                    if (nameA > nameB) { return 1; }
                                                                    return 0;
                                                                })
                                                                .map((el, key) => {
                                return(
                                    <div key={ key } className='option-row' onClick={() => onAddElt(el)}>
                                    {/* <div key={ key } className='option-row'> */}
                                        <i className="fa fa-plus-square" 
                                            aria-hidden="true"
                                            style={{ color: "#3ad33a" }}></i>
                                        {/* <input type='checkbox' /> */}
                                        <div className="category-item-in-list" > 
                                            { el && el.Name } 
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    
                </div>
            </div>
        </>
    );
};

export default MultiSelect;